import { render, staticRenderFns } from "./ItsStockRawReturn.vue?vue&type=template&id=49a2f2cc&scoped=true&"
import script from "./ItsStockRawReturn.vue?vue&type=script&lang=js&"
export * from "./ItsStockRawReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a2f2cc",
  null
  
)

export default component.exports